import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { getChiTietSanPhamKhacPhucLoi } from '../../../redux/category/action';
import { _ghiNhanHuuIchKhacPhucLoi } from '../../../api/baoHanh';
import BaoLoiModal from './modalSubmitLoi';

const HUU_ICH_STORAGE_KEY = 'gc_khacphucloi_huuich';

const loadLikedFaqIds = () => {
  try {
    const raw = localStorage.getItem(HUU_ICH_STORAGE_KEY);
    return raw ? new Set(JSON.parse(raw)) : new Set();
  } catch {
    return new Set();
  }
};

const saveLikedFaqIds = (set) => {
  try {
    localStorage.setItem(HUU_ICH_STORAGE_KEY, JSON.stringify(Array.from(set)));
  } catch {
    // localStorage không khả dụng (chế độ ẩn danh...), bỏ qua việc lưu
  }
};

const ThumbUpIcon = ({ filled }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill={filled ? '#2563eb' : 'none'} stroke={filled ? '#2563eb' : '#777'} strokeWidth="2">
    <path d="M7 10v12H4a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1z" />
    <path d="M9 10l4-7a2 2 0 0 1 2 2v5h5.5a2 2 0 0 1 1.96 2.4l-1.6 8A2 2 0 0 1 18.9 22H9a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1z" />
  </svg>
);

const DocIcon = ({ type }) => {
  if (type === 'video')
    return (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <polygon points="10 8 16 12 10 16 10 8" fill="#ef4444" stroke="none" />
      </svg>
    );
  if (type === 'docx')
    return (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="8" y1="13" x2="16" y2="13" />
        <line x1="8" y1="17" x2="13" y2="17" />
      </svg>
    );
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <path d="M9 15l2 2 4-4" stroke="#dc2626" />
    </svg>
  );
};

const ChiTietKhacPhuc = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const model = params.get('model');

  const chiTietSanPham = useSelector((store) => store.categories.chiTietSanPham);
  const [openFaq, setOpenFaq] = useState(0);
  const [showBaoLoi, setShowBaoLoi] = useState(false);
  const [likedFaqIds, setLikedFaqIds] = useState(loadLikedFaqIds);
  const [sessionLikedIds, setSessionLikedIds] = useState(new Set());
  const [likingId, setLikingId] = useState(null);

  useEffect(() => {
    dispatch(getChiTietSanPhamKhacPhucLoi(model));
  }, [model]);

  const handleHuuIch = async (faqId, storageKey, loaiLog) => {
    if (likedFaqIds.has(storageKey) || likingId === storageKey) return;
    setLikingId(storageKey);
    try {
      await _ghiNhanHuuIchKhacPhucLoi(faqId, loaiLog);
      setLikedFaqIds((prev) => {
        const next = new Set(prev).add(storageKey);
        saveLikedFaqIds(next);
        return next;
      });
      setSessionLikedIds((prev) => new Set(prev).add(storageKey));
    } catch (error) {
      toast.error('Không thể ghi nhận đánh giá, vui lòng thử lại');
    } finally {
      setLikingId(null);
    }
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", background: '#f8f9fa', minHeight: '100vh', padding: '32px 16px' }}>
      <style>{`
        .ct-hero { display: flex; flex-wrap: wrap; }
        .ct-hero-img { width: 320px; min-height: 260px; flex-shrink: 0; background: linear-gradient(135deg,#e0e7ff,#f0f4ff); display: flex; align-items: center; justify-content: center; }
        .ct-two-col { display: flex; gap: 24px; align-items: flex-start; }
        .ct-left { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 24px; }
        .ct-right { width: 280px; flex-shrink: 0; display: flex; flex-direction: column; gap: 16px; }
        .ct-docs-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
        .ct-faq-content { max-width: 100%; overflow-wrap: break-word; word-break: break-word; }
        .ct-faq-content img, .ct-faq-content video, .ct-faq-content iframe { max-width: 100%; height: auto; border-radius: 8px; display: block; margin: 8px 0; }
        .ct-faq-content table { max-width: 100%; display: block; overflow-x: auto; }
        .ct-faq-item { border: 1px solid #e5e9f0; border-radius: 12px; background: #fff; overflow: hidden; transition: border-color .15s, box-shadow .15s; }
        .ct-faq-item:hover { border-color: #cbd5e1; box-shadow: 0 2px 10px rgba(0,0,0,0.05); }
        .ct-faq-header:hover { background: #f8fafc; }
        .ct-huuich-btn:not(:disabled):hover { border-color: #2563eb; color: #2563eb; }

        @media (max-width: 992px) {
          .ct-two-col { flex-direction: column; }
          .ct-right { width: 100%; flex-direction: row; flex-wrap: wrap; display: flex; }
          .ct-right > * { flex: 1 1 260px; }
        }
        @media (max-width: 768px) {
          .ct-hero-img { width: 100%; min-height: 180px; }
          .ct-docs-grid { grid-template-columns: 1fr; }
          .ct-faq-header { flex-wrap: wrap; }
          .ct-huuich-btn span { display: none; }
        }
      `}</style>

      <div style={{ maxWidth: 1400, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 24 }}>
        {/* ── Hero ── */}
        <div className="ct-hero" style={{ background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
          <div className="ct-hero-img">
            <svg width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="0.8">
              <rect x="2" y="3" width="20" height="14" rx="2" />
              <path d="M8 21h8M12 17v4" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </div>
          <div style={{ flex: 1, padding: '36px 32px', minWidth: 260 }}>
            <h1 style={{ fontSize: '1.6rem', fontWeight: 800, color: '#1a1a2e', margin: '0 0 6px' }}>
              {chiTietSanPham?.ThongTinSanPham?.MA_DIEU_CHINH || 'Đang tải...'}
            </h1>
            <p style={{ color: '#2563eb', fontSize: 13, fontWeight: 600, margin: '0 0 18px' }}>
              Thương hiệu: {chiTietSanPham?.ThongTinSanPham?.MA_NHOM_HANG || '—'}
            </p>
            <p style={{ color: '#555', fontSize: 14, lineHeight: 1.7, margin: '0 0 28px' }}>{chiTietSanPham?.ThongTinSanPham?.TEN_HANG || ''}</p>
          </div>
        </div>

        {/* ── Two column ── */}
        <div className="ct-two-col">
          {/* LEFT */}
          <div className="ct-left">
            {/* Hướng dẫn sử dụng */}
            <div style={{ background: '#fff', borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', padding: 24 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 18 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                </svg>
                <h2 style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e', margin: 0 }}>Hướng dẫn sử dụng</h2>
              </div>

              {chiTietSanPham?.HuongDanSuDung?.length ? (
                <div className="ct-docs-grid">
                  {chiTietSanPham.HuongDanSuDung.map((d, i) => (
                    <a key={i} href={d.LinkVideo || '#'} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                      <div
                        style={{
                          border: '1.5px solid #e2e8f0',
                          borderRadius: 10,
                          padding: '12px 14px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: 10,
                          cursor: 'pointer',
                          transition: 'border-color .15s, background .15s',
                          background: '#fff',
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.borderColor = '#2563eb';
                          e.currentTarget.style.background = '#eff6ff';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.borderColor = '#e2e8f0';
                          e.currentTarget.style.background = '#fff';
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <DocIcon type={d.HinhThuc?.toLowerCase()} />
                          <div>
                            <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: '#333' }}>{d.TieuDe}</p>
                            <p style={{ margin: 0, fontSize: 11, color: '#aaa' }}>{d.HinhThuc}</p>
                          </div>
                        </div>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2">
                          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                          <polyline points="15 3 21 3 21 9" />
                          <line x1="10" y1="14" x2="21" y2="3" />
                        </svg>
                      </div>
                    </a>
                  ))}
                </div>
              ) : (
                <p style={{ fontSize: 13, color: '#aaa', textAlign: 'center', padding: '24px 0', margin: 0 }}>
                  Chưa có dữ liệu, chúng tôi đang cố gắng cập nhật sớm nhất.
                </p>
              )}
            </div>

            {/* Khắc phục lỗi */}
            <div style={{ background: '#fff', borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', padding: 24 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
                  <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
                </svg>
                <h2 style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e', margin: 0 }}>Khắc phục lỗi</h2>
              </div>

              {chiTietSanPham?.KhacPhucLoi?.length ? (
                chiTietSanPham.KhacPhucLoi.map((faq, i) => {
                  const faqId = faq.ID;
                  const storageKey = `${model || ''}::${faqId}`;
                  const isLiked = likedFaqIds.has(storageKey);
                  const soLuongGoc = faq.SoLuongHuuIch ?? faq.SoHuuIch ?? 0;
                  const soLuongHienThi = soLuongGoc + (sessionLikedIds.has(storageKey) ? 1 : 0);
                  const isOpen = openFaq === i;

                  return (
                    <div key={i} className="ct-faq-item" style={{ marginBottom: i < chiTietSanPham.KhacPhucLoi.length - 1 ? 12 : 0 }}>
                      <div
                        className="ct-faq-header"
                        role="button"
                        tabIndex={0}
                        onClick={() => setOpenFaq(isOpen ? null : i)}
                        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setOpenFaq(isOpen ? null : i)}
                        style={{
                          padding: '14px 16px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          cursor: 'pointer',
                          gap: 12,
                        }}
                      >
                        <span style={{ fontSize: 14, fontWeight: 500, color: '#1a1a2e', flex: 1, minWidth: 0 }}>{faq.TieuDe}</span>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#888"
                          strokeWidth="2"
                          style={{ flexShrink: 0, transform: isOpen ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform .2s' }}
                        >
                          <polyline points="6 9 12 15 18 9" />
                        </svg>
                      </div>
                      {isOpen && faq.NoiDung && (
                        <div style={{ padding: '0 16px 16px' }}>
                          <div
                            className="ct-faq-content"
                            style={{ paddingLeft: 14, borderLeft: '3px solid #2563eb', fontSize: 13.5, lineHeight: 1.7, color: '#444' }}
                            dangerouslySetInnerHTML={{ __html: faq.NoiDung }}
                          />
                          <div
                            className="ct-huuich-row"
                            style={{
                              display: 'flex',
                              justifyContent: 'end',
                              alignItems: 'center',
                              gap: 10,
                              marginTop: 16,
                              paddingTop: 14,
                              borderTop: '1px solid #f1f5f9',
                              flexWrap: 'wrap',
                            }}
                          >
                            <span style={{ fontSize: 12, color: '#555' }}>Nội dung này có hữu ích không?</span>
                            <button
                              type="button"
                              className="ct-huuich-btn"
                              disabled={isLiked || likingId === storageKey}
                              onClick={() => handleHuuIch(faqId, storageKey, faq.LoaiLog)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 6,
                                background: isLiked ? '#eff6ff' : '#fff',
                                border: `1px solid ${isLiked ? '#bfdbfe' : '#e2e8f0'}`,
                                color: isLiked ? '#2563eb' : '#555',
                                borderRadius: 8,
                                padding: '5px 12px',
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: isLiked ? 'default' : 'pointer',
                                transition: 'border-color .15s, color .15s',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              <ThumbUpIcon filled={isLiked} />
                              {isLiked ? 'Đã đánh giá' : 'Hữu ích'}
                              {soLuongHienThi > 0 && <span style={{ opacity: 0.7 }}>({soLuongHienThi})</span>}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <p style={{ fontSize: 13, color: '#aaa', textAlign: 'center', padding: '24px 0', margin: 0 }}>
                  Chưa có dữ liệu, chúng tôi đang cố gắng cập nhật sớm nhất.
                </p>
              )}
            </div>
          </div>

          {/* RIGHT */}
          <div className="ct-right">
            {/* Báo lỗi */}
            <div style={{ background: 'linear-gradient(135deg,#1e40af,#2563eb)', borderRadius: 14, padding: 24, color: '#fff' }}>
              <div style={{ marginBottom: 12 }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.9)" strokeWidth="2">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                  <line x1="12" y1="9" x2="12" y2="13" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
              </div>
              <h3 style={{ fontSize: 15, fontWeight: 700, margin: '0 0 8px' }}>Bạn đang gặp sự cố?</h3>
              <p style={{ fontSize: 13, lineHeight: 1.6, margin: '0 0 18px', opacity: 0.85 }}>
                Đội ngũ hỗ trợ kỹ thuật sẵn sàng giúp bạn giải quyết mọi sự cố.
              </p>
              <button
                onClick={() => setShowBaoLoi(true)}
                style={{
                  width: '100%',
                  background: '#fff',
                  color: '#2563eb',
                  border: 'none',
                  borderRadius: 10,
                  padding: '11px 0',
                  fontWeight: 700,
                  fontSize: 13,
                  cursor: 'pointer',
                }}
              >
                BÁO LỖI SẢN PHẨM
              </button>
            </div>

            {/* Liên hệ */}
            <div style={{ background: '#fff', borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', padding: 24 }}>
              <h3 style={{ fontSize: 14, fontWeight: 700, color: '#1a1a2e', margin: '0 0 16px' }}>Liên hệ hỗ trợ nhanh</h3>
              {[
                {
                  icon: (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.06 6.06l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                  ),
                  label: 'Đường dây nóng (24/7)',
                  value: '+1 (800) 555-GIGA',
                  bold: true,
                },
                {
                  icon: (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  ),
                  label: 'Phản hồi qua Email',
                  value: 'support@gigacare.tech',
                  bold: true,
                },
                {
                  icon: (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                  ),
                  label: 'Chat trực tiếp',
                  value: 'Chờ khoảng: 2 phút',
                  bold: false,
                },
              ].map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 12,
                    padding: '12px 0',
                    borderBottom: i < 2 ? '1px solid #f1f5f9' : 'none',
                  }}
                >
                  <div
                    style={{
                      width: 32,
                      height: 32,
                      background: '#eff6ff',
                      borderRadius: 8,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    {item.icon}
                  </div>
                  <div>
                    <p style={{ margin: 0, fontSize: 12, color: '#888' }}>{item.label}</p>
                    <p style={{ margin: 0, fontSize: 13, fontWeight: item.bold ? 700 : 400, color: '#1a1a2e' }}>{item.value}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Certification */}
            <div style={{ background: '#f8faff', border: '1.5px solid #dbeafe', borderRadius: 14, padding: '16px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
                  <circle cx="12" cy="8" r="6" />
                  <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
                </svg>
                <span style={{ fontSize: 12, fontWeight: 700, color: '#2563eb' }}>DỊCH VỤ CHỨNG NHẬN</span>
              </div>
              <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: '#1a1a2e' }}>Điểm tin cậy: 9.8/10</p>
              <p style={{ margin: '4px 0 0', fontSize: 12, color: '#555' }}>Hỗ trợ đạt chứng nhận ISO 27001 về bảo vệ dữ liệu.</p>
            </div>
          </div>
        </div>
      </div>

      <BaoLoiModal open={showBaoLoi} onClose={() => setShowBaoLoi(false)} model={chiTietSanPham?.ThongTinSanPham} />
    </div>
  );
};

export default ChiTietKhacPhuc;
